import { ReactElement } from 'react';
import { TextInput as TextFieldComponent } from '@ebsco-ui/ebsco-ui';

import { PropsWithClassName } from '@app/constants';

import { FieldWrapper } from './FieldWrapper';
import { FieldProps } from './constants';

export const TextField = (
  props: PropsWithClassName<FieldProps>
): ReactElement => <FieldWrapper component={TextFieldComponent} {...props} />;
